<template>
    <v-card>
        <v-card-title class="headline grey darken-4">
            Informar CPF na nota fiscal
            <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text class="pt-4">
            <v-container>
                <v-row>
                    <v-col cols="12">
                        <Input v-model="cpf" mask="###.###.###-##" @keydown.enter="checkCPF(cpf)" />
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    import { mapActions } from "vuex";

    export default {
        data() {
            return {
                cpf: "",
            };
        },
        methods: {
            ...mapActions("customer", ["showByCPF", "showByCard"]),

            validateCPF(cpf) {
                const cleanedCpf = cpf.replace(/[^\d]+/g, '');
                if (cleanedCpf.length !== 11) {
                    return false;
                }
                if (/^(\d)\1{10}$/.test(cleanedCpf)) {
                    return false;
                }
                const digits = cleanedCpf.split('').map(Number);
                const firstDigit = this.calculateDigit(digits.slice(0, 9));
                const secondDigit = this.calculateDigit(digits.slice(0, 10));
                return digits[9] === firstDigit && digits[10] === secondDigit;
            },

            calculateDigit(numbers) {
                const weight = numbers.length + 1;
                const sum = numbers.reduce((acc, num, index) => acc + num * (weight - index), 0);
                const remainder = sum % 11;
                return remainder < 2 ? 0 : 11 - remainder;
            },

            checkCPF(cpf) {
                if (!this.validateCPF(cpf)) {
                    this.$toast.error("CPF inválido. Verifique o formato.");
                    return;
                }
                this.showByCPF(cpf).then((response) => {
                    this.$emit('close-dialog');
                    this.showByCard(response.data.id);
                    this.cpf = "";
                })
            },
        },
    };
</script>
